import { createContext } from "react"
import { Communicator } from "./communicator"

export const CommunicatorContext = createContext(<Communicator.Service><unknown>undefined)
